import { useState } from 'react';
import { UseDistanceInterface, UseSelectionInterface } from './Filter.interface';

export const distanceLabelHandler = (value: string) => `${value} km`;

const useDistance = ({ checkedEntity, onChangeHandler }: UseSelectionInterface, RegExp: RegExp): UseDistanceInterface => {
  const [isValid, setIsValid] = useState<RegExpMatchArray | null>(null);
  const enhancedChangeHandler = (value: string) => {
    const postalCode = value.toString().trim();

    const isValidRegExp = postalCode.match(RegExp);

    if (isValidRegExp) {
      onChangeHandler(value);
      setIsValid(isValidRegExp);
    }
  };

  return {
    checkedEntity,
    onChangeHandler: enhancedChangeHandler,
    isValid,
  };
};

export default useDistance;
